import Vue from 'vue';
import Router from 'vue-router';
import Api from './utils/api';

// Views
import Login from './views/Login';
import ForgotPassword from './views/ForgotPassword';
import ResetPassword from "./views/ResetPassword";

import Home from './views/Home';
import Dashboard from './views/Dashboard/Dashboard';
import ClientForm from './views/Client/ClientForm';
import AdminForm from "./views/Admin/AdminForm";
import ClientList from "./views/Client/ClientList";
import AffiliateList from "@/views/Affiliate/AffiliateList";
import AffiliateForm from "@/views/Affiliate/AffiliateForm";
import AffiliateClientList from "@/views/Affiliate/AffiliateClientList";
import TransactionList from "@/views/Transaction/TransactionList";
import WhatsappList from "./views/Whatsapp/WhatsappList";
import WhatsappForm from "./views/Whatsapp/WhatsappForm";
import ReminderTypeList from "@/views/ReminderType/ReminderTypeList.vue";
import ReminderTypeForm from "@/views/ReminderType/ReminderTypeForm.vue";
import UnitList from "@/views/Unit/UnitList.vue";
import UnitForm from "@/views/Unit/UnitForm.vue";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/esqueci-a-senha',
      component: ForgotPassword
    },
    {
      path: '/redefinir-senha/:token',
      component: ResetPassword
    },
    {
      path: '/',
      component: Home,
      children: [
        { path: '', component: Dashboard, meta: { requiresAuth: true } },

        { path: 'informacoes-pessoais', component: AdminForm, meta: { requiresAuth: true } },

        { path: 'clientes', component: ClientList, meta: { requiresAuth: true } },
        { path: 'clientes/:id', component: ClientForm, meta: { requiresAuth: true } },

        { path: 'transacoes', component: TransactionList, meta: { requiresAuth: true } },

        { path: 'contas-de-whatsapp', component: WhatsappList, meta: { requiresAuth: true } },
        { path: 'contas-de-whatsapp/:id', component: WhatsappForm, meta: { requiresAuth: true } },

        { path: 'afiliados', component: AffiliateList, meta: { requiresAuth: true } },
        { path: 'afiliados/:id', component: AffiliateForm, meta: { requiresAuth: true } },

        { path: 'indicacoes', component: AffiliateClientList, meta: { requiresAuth: true } },

        { path: 'tipos-de-lembrete', component: ReminderTypeList, meta: { requiresAuth: true } },
        { path: 'tipos-de-lembrete/:id', component: ReminderTypeForm, meta: { requiresAuth: true } },

        { path: 'unidades', component: UnitList, meta: { requiresAuth: true } },
        { path: 'unidades/:id', component: UnitForm, meta: { requiresAuth: true } },
      ],
      meta: { requiresAuth: true }
    }
  ]
});

router.beforeEach((to, from, next) => {
  Api.checkVersion();

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Api.isLogged()) {
      next({path: '/login'})
    } else {
      next()
    }
  } else {
    next()
  }
});

// router.afterEach((to, from) => {
//   if(to.meta.requiresAuth && Api.checkTrial(to) && to.path != from.path) {
//     router.push({ path: '/minha-assinatura' });
//   }
// });

export default router
